export enum AdminAction {
  CONSULTAR = 'CONSULTAR',
  INCLUIR = 'INCLUIR',
  ALTERAR = 'ALTERAR',
  EXCLUIR = 'EXCLUIR',
  EXPORTAR = 'EXPORTAR',
  AUTORIZAR = 'AUTORIZAR',
  CANCELAR = 'CANCELAR',
  APROVAR = 'APROVAR',
  BAIXAR = 'BAIXAR',
  ESTORNAR_BAIXA = 'ESTORNAR_BAIXA',
  ESTORNAR = 'ESTORNAR',
  CONCLUIR = 'CONCLUIR',
  REABRIR = 'REABRIR',
}
